import React from "react";
import { FaLinkedinIn, FaGithubAlt, FaDev, FaTwitter } from "react-icons/fa";
import { NavIcons } from "./SocialNavStyles.js";

function SocialNavIcons(props) {
   return (
      <NavIcons {...props}>
         <a href="https://www.linkedin.com/in/paras594/" target="_blank">
            <FaLinkedinIn />
         </a>
         <a href="https://github.com/paras594" target="_blank">
            <FaGithubAlt />
         </a>
         <a href="https://dev.to/paras594" target="_blank">
            <FaDev />
         </a>
         <a href="https://twitter.com/paras594" target="_blank">
            <FaTwitter />
         </a>
      </NavIcons>
   );
}

export default SocialNavIcons;
